import React from 'react';

export default class Loader extends React.Component {
    render () {
        return (
            <div className="component-loader"></div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/loader/Loader.jsx
 **/